import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import { FeedPageContext } from '../../..'
import { useFormContext, useWatch } from 'react-hook-form'
import { Form, Message } from 'semantic-ui-react'
import cloneDeep from 'lodash.clonedeep'
import { formatNumber } from '~/utils/helpers'
import { monthsArray } from './Phases/CreatePhasesModal'

const AssignPhasesModal: React.FC = () => {
  const { t } = useTranslation()
  const { feedPage, setFeedPage } = useContext(FeedPageContext)
  const { control, setValue } = useFormContext()

  const watchFeedingPhases = useWatch({ control, name: 'feedingPhases' })
  const watchPhaseEnabled = useWatch({ control, name: 'phaseFeeding' })
  const watchFeedGroups = useWatch({ control, name: 'feedGroups' })
  const watchCalvingPeriod = useWatch({ control, name: 'calvingPeriod' })
  const watchCowsNumber = useWatch({ control, name: 'cowsNumber' })

  const [selectedFeedGroups, setSelectedFeedGroups] = useState([])

  useEffect(() => {
    const selectedFeedGroups = []
    watchFeedGroups.map((feedGroup, index) => {
      if (feedGroup?.feedingPhases?.length > 0) {
        selectedFeedGroups.push(index)
      }
    })
    setSelectedFeedGroups(selectedFeedGroups)
  }, [])

  function renderAssignPhasesContent() {
    return <div>
      <Message info style={{ textAlign: 'center', borderRadius: 5 }}>
        <div>{t('Phase(n): ')}
          {watchFeedingPhases?.map((feedingPhase, index) => {
            return <span key={feedingPhase.name}>{`${feedingPhase.name} (${monthsArray[feedingPhase.months - 1].label})${index === 0 ? ', ' : ' '}`}</span>
          })}
        </div>
      </Message>
      <Form>
        <Form.Select
          multiple
          selectOnBlur={false}
          selection
          placeholder={t('Select feed groups')}
          value={selectedFeedGroups}
          onChange={(_, data) => setSelectedFeedGroups(data.value as (string | number | boolean)[])}
          options={watchFeedGroups?.map((feedGroup, index) => {
            const cowsNrInRelToDaysGroup = parseInt(watchCowsNumber) / parseInt(watchCalvingPeriod) * feedGroup['days']
            return { value: index, text: `${feedGroup.name} (${formatNumber(cowsNrInRelToDaysGroup, 0)} Tiere)` }
          })}
        />
      </Form>
    </div>
  }

  function handleSubmitPhases() {
    const tempFeedGroups = cloneDeep(watchFeedGroups)
    tempFeedGroups.forEach((feedGroup, index) => {
      const selectedGroup = selectedFeedGroups.find(selectedFeedGroupIndex => selectedFeedGroupIndex === index)
      if (selectedGroup !== undefined) {
        if (feedGroup.feedingPhases?.length > 0) {
          feedGroup.feedingPhases.forEach((feedingPhase, index) => {
            const phaseData = index === 0 ? watchFeedingPhases[0] : watchFeedingPhases[1]
            feedingPhase = {
              ...feedingPhase,
              ...phaseData
            }
          })
        } else {
          feedGroup.feedingPhases = [
            {
              ...watchFeedingPhases[0],
              concentratedFeeds: [],
              juicyFeeds: [],
              coarseFeeds: []
            },
            {
              ...watchFeedingPhases[1],
              concentratedFeeds: [],
              juicyFeeds: [],
              coarseFeeds: []
            }
          ]
        }
      } else {
        tempFeedGroups[index] = {
          ...feedGroup,
          feedingPhases: []
        }
      }
    })
    setValue('feedGroups', tempFeedGroups)
    setFeedPage(2)
  }

  return <Dialog
    handleClose={() => {
      setFeedPage(0)
      setSelectedFeedGroups([])
    }}
    textClose={t('Cancel')}
    textHeader={t('Assignment of phases to performance groups')}
    isDialogOpen={feedPage === 1 && watchPhaseEnabled === 1}
    noScrollingContent
    textSubmit={t('Assign phases')}
    textContent={renderAssignPhasesContent()}
    disableSubmit={selectedFeedGroups.length === 0}
    handleSubmit={() => handleSubmitPhases()}
  />
}
export default AssignPhasesModal